import madApe01 from '../images/apes/alphas/mad-ape-001.svg';
import madApe02 from '../images/apes/alphas/mad-ape-002.svg';
import madApe03 from '../images/apes/alphas/mad-ape-003.svg';
import madApe04 from '../images/apes/alphas/mad-ape-004.svg';


const meetApes = [
  madApe01, madApe02, madApe03, madApe04, madApe01, madApe02, madApe03, madApe04
]

export default meetApes;